import Department from "./department"
import EmployeeClass from "./employee-class"
import { Gender, JobTitle, OfficeLocation, Status } from "./org-chart-node"
import { EmployeeType } from "./employee-type"
import { Queryable } from "./queryable"
import VacationHours from "./vacation-hours"
import Project from "./project"
import Rocks from "./rocks"
import { ClientEngagement } from "./client-engagement"
import { IndustryEngagement, IndustryEngagementAttendee } from "./industry-engagement"
import Opportunity from "./opportunity"
import Address from "./address"

export default interface Employee {
    id: string
    userId?: string | null
    employeeCode?: string | null
    jobTitleId?: string | null
    managerId?: string | null
    identityId?: string | null
    genderId?: string | null
    locationId?: string | null
    statusId?: string | null
    typeId?: string | null
    employeeClassId?: string | null
    departmentId?: string | null
    addressId?: string | null
    firstName: string
    commonName?: string | null
    lastName: string
    companyEmail?: string | null
    personalEmail?: string | null
    phoneNumber?: string | null
    hireDate?: Date | null
    terminatedAt?: Date | null
    contractEndDate?: Date | null
    deletedAt?: Date | null
    aboriginalStatus?: boolean
    billability?: number | string | null
    willingToRelocate: boolean
    esaExempt?: boolean
    nonProfessional?: boolean
    inactiveReason?: string | null
    createdAt?: Date
    updatedAt?: Date

    // Navigation (all optional; populated fields depend on which endpoint returned this)
    jobTitle?: JobTitle
    manager?: Employee
    directReports?: Employee[]
    department?: Department
    headOfDepartments?: Department[]
    location?: OfficeLocation
    employeeStatus?: Status
    employeeType?: EmployeeType
    employeeClass?: EmployeeClass
    gender?: Gender
    identity?: { id: string, description: string } | null
    user?: { id: string, email: string } | null
    emergencyContacts?: { id: string, firstName: string, lastName: string, phoneNumber: string, relationType?: { name: string } }[]
    designations?: {
        startDate: Date | string
        endDate?: Date | string | null
        designation?: { description: string }
        designationStatus?: { description: string }
    }[]
    industryEngagementAttendees?: IndustryEngagementAttendee[]
    vacationHours?: VacationHours[]
    projects?: Project[]
    opportunities?: Opportunity[]
    address?: Address

    createdClientEngagements?: ClientEngagement[]
    updatedClientEngagements?: ClientEngagement[]
    deletedClientEngagements?: ClientEngagement[]
    industryEngagementsCreated?: IndustryEngagement[]
    industryEngagementsUpdated?: IndustryEngagement[]
    industryEngagementsDeleted?: IndustryEngagement[]
    accountableRocks?: Rocks[]
    createdRocks?: Rocks[]
    updatedRocks?: Rocks[]
}

export interface IEmployeeQueryParams extends Queryable {
    employeeCode?: string
    name?: string
    jobTitleId?: string
    managerId?: string
    departmentId?: string
    province?: string
    statusId?: string
    employeeTypeId?: string[]
}

export const DEFAULT_EMPLOYEE_QUERY: IEmployeeQueryParams = {
    page: 0,
    limit: Number.MAX_SAFE_INTEGER,
    employeeCode: '',
    name: '',
    jobTitleId: '',
    managerId: '',
    departmentId: '',
    province: '',
    statusId: '',
    employeeTypeId: []
}
